import formatNumber from '@/utils/format-number'

export const formatRune = (v: any, data: any) => {
	if (v === '0') {
		return '0 ' + data.symbol
	}

	return formatNumber(parseInt(v) / Math.pow(10, data?.divisibility)) + ' ' + data?.symbol
}

export const spaceRune = (rune: any) => {
	let r = rune.toUpperCase()

	while (r.includes(' ')) {
		r = r.replace(' ', '•')
	}

	return r
}
